module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image2_sale2-e289674594de88ee55a6cf5bf38b150b.png";